module.exports = __webpack_public_path__ + "img/login_tab02_04.2cb321d5.png";